import React from 'react';
import { Button, Alert, AlertVariantType } from '../../common';
import StandardModal from '../../common/modals/StandardModal';
import { FileUpload } from '@emorg-prd/standard-react';
import CSVGeneratorButton from '../../common/CSVGeneratorButton';
import { AppColumnsLayout, AppColumnsExample, AppColumn } from './AppColumnsLayout';
import { AlertBanner } from '../../../models/interfaces/AlertBanner';

interface BulkUploadModalProps {
	onSuccess: (apps: []) => any;
	onCancel: (...args: any[]) => any;
	visible: boolean;
	applicationService: any;
}

interface BulkUploadModalState {
	loading: boolean;
	file: any;
	alert: AlertBanner;
	templateColumns: AppColumn[];
	exampleColumn: any;
}

export default class BulkUploadModal
	extends React.Component<BulkUploadModalProps, BulkUploadModalState> {
	
	applicationService: any;

	constructor(props: BulkUploadModalProps) {
		super(props);

		this.applicationService = this.props.applicationService;

		this.state = {
			loading: false,
			file: null,
			alert: {
				visible: false,
			},
			templateColumns: AppColumnsLayout,
			exampleColumn: AppColumnsExample
		};
	}

	handleChange = (event) => {
		const file = event?.target?.files?.[0] ?? event?.[0] ?? event;
		this.setState({ file });
	};

	handleUpload = async () => {
		this.setState({
			loading: true
		});

		this.applicationService.parse(this.state.file)
			.then((response: []) => {
				this.props.onSuccess(response);
			})
			.catch(err => {
				this.setState({
					alert: {
						visible: true,
						text: err.message,
						variant: 'error',
					}
				});
			})
			.finally(() => {
				this.setState({
					loading: false,
					file: null
				});
			});
	};

	render() {
		return (
			<StandardModal
				show={this.props.visible}
				title="Import applications to the request"
				onDismiss={this.props.onCancel}
				footer={
					<Button
						variant="primary"
						onClick={this.handleUpload}
						loading={this.state.loading}
						disabled={(!this.state.file) || this.state.alert.visible}
					>
						Preview Applications
					</Button>
				}
			>
				<CSVGeneratorButton
					label="Download Template"
					columns={this.state.templateColumns ?? []}
					fileName={`Template-Applications-To-Import.csv`}
					data={this.state.exampleColumn}
				/>
				{!this.state.alert.visible && <FileUpload
					multiple={false}
					onChange={this.handleChange}
				/>}
				{this.state.alert.visible &&
					<Alert
						variant="error"
						body={this.state.alert.text}
						onClose={() => {
							this.setState({
								alert: { visible: false },
								file: null,
							});
						}}
					/>
				}
			</StandardModal>
		);
	}
}